<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Список ДТП"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-account-card-details"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          ДТП
        </div>
      </template>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        multi-sort
      >
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.date.from"
                    label="Дата начала"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.date.to"
                    label="Дата конца"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>

                <v-col cols="1">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="load"
                  >
                    Поиск
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:item.driver="{ item }">
          <span class="text-uppercase">{{ item.first.driver.surname }} {{ item.first.driver.name }} {{ item.first.driver.patronymic }}</span>
        </template>
        <template v-slot:item.owner="{ item }">
          <span class="text-uppercase">{{ item.first.owner.surname }} {{ item.first.owner.name }} {{ item.first.owner.patronymic }}</span>
        </template>
        <template v-slot:item.phone="{ item }">
          <span>{{ item.first.driver.phone }}</span>
        </template>
        <template v-slot:item.vehicle="{ item }">
          <span class="text-uppercase">
            {{ item.first.vehicle.model }}, госномер: {{ item.first.vehicle.number }}
          </span>
        </template>
        <template v-slot:item.common="{ item }">
          <span>{{ item.common.date_formatted }} {{ item.common.time }}</span>
        </template>
        <template v-slot:item.settings="{ item }">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>
                <v-icon
                  color="primary"
                  large
                  class="mr-2"
                  @click="sheetitem = item, sheet = true"
                >
                  mdi-cog
                </v-icon>
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.commissar">
                {{ item.commissar.surname }} {{ item.commissar.name }} {{ item.commissar.patronymic }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td colspan="6">
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <v-list-item
                  v-for="(line, index) in item.docs.filter(a=>a.hide!=true)"
                  :key="index"
                >
                  <v-list-item-content>
                    <v-list-item-title class="display-1">
                      {{ line.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon
                        color="grey lighten-1"
                        @click="getDoc(line)"
                      >
                        mdi-content-save
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-model="dialog.show"
      persistent
      scrollable
      max-width="50%"
    >
      <v-card class="elevation-1">
        <v-card-title class="headline">
          Изменение статуса
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-container
              grid-list-md
              fluid
            >
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="dialog.item.state"
                    :items="select.state"
                    label="Статус"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn
            color="primary"
            flat
            @click="dialog.show = false"
          >
            Назад
          </v-btn>
          <v-spacer />
          <v-btn
            color="red"
            flat
            min-width="100"
            @click="change_state"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-list>
        <v-list-group v-model="sheetmenu">
          <v-list-item slot="activator">
            <v-list-item-action>
              <v-icon>mdi-build</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Действия</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :disabled="sheetitem.state!=1"
            @click="$router.push('/accident/change/' + sheetitem.id)"
          >
            <v-list-item-content>
              Редактировать ДТП
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group>
          <v-list-item slot="activator">
            <v-list-item-action>
              <v-icon>mdi-folders</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Документы</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(line, index) in sheetitem.docs.filter(a=>a.hide!=true)"
            :key="index"
            @click="getDoc(line)"
          >
            <v-list-item-content>
              <v-list-item-title class="display-1">
                {{ line.name }} {{ line.created }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-bottom-sheet>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      overlay: false,
      dialog: {
        show: false,
        item: {},
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {
        docs: [],
      },
      headers: [
        {
          text: 'Действия',
          value: 'settings',
        },
        {
          text: 'Дата и время происшествия',
          value: 'common',
        },
        {
          text: 'Телефон',
          value: 'phone',
        },
        {
          text: 'Собственник',
          value: 'owner',
        },
        {
          text: 'Водитель',
          value: 'driver',
        },

        {
          text: 'Автомобиль',
          value: 'vehicle',
        },
      ],
      items: [],
      search: undefined,
      form: {
        date: {
          from: '',
          to: '',
        },
        doc: {
          series: '',
          number: '',
        },
        doc_insurance: {
          series: '',
          number: '',
        },
        number: '',
        name: '',
        vin: '',
        phone: '',
      },
      dict: {
        state: {
          1: 'Черновик',
          2: 'Новый',
          3: 'Оформлен',
          4: 'Удален',
        },
      },
      select: {
        state: [
          { value: 1, text: 'Черновик' },
          { value: 2, text: 'Новый' },
          { value: 3, text: 'Оформлен' },
          { value: 4, text: 'Удален' },
        ],
        users: [],
      },
    }),
    mounted: function () {
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      this.axios.post('/api/user/get/', {})
        .then(response => {
          if (!response.data.error) {
            this.select.users = response.data.data
          } else {

          }
        })
        .catch(e => {

        })
      this.load()
    },
    methods: {
      clear: function () {
        this.form = {
          date: {
            from: '',
            to: '',
          },
          doc: {
            series: '',
            number: '',
          },
          doc_insurance: {
            series: '',
            number: '',
          },
          number: '',
          name: '',
          vin: '',
          phone: '',
        }
        this.form.date.from = moment().format('YYYY-MM-DD')
        this.form.date.to = moment().format('YYYY-MM-DD')
      },
      generateFiles: function (id) {
        this.overlay = true
        this.sheet = false
        this.$axios.post('/api/accident/generate/' + id)
          .then(response => {
            this.overlay = false
            if (!response.data.error) {
              this.load()

              this.$store.commit('snackbar', 'Список файлов обновлен')
            } else {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            this.overlay = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      getDoc: function (item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      getExcel: function () {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/accident/excel',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: JSON.stringify(this.form),
            name: 'filter',
          })
        )
        form.appendTo('body').submit()
      },
      change_state: function () {
        this.overlay = true
        this.axios.post('/api/accident/state', { id: this.dialog.item.id, state: this.dialog.item.state })
          .then(result => {
            this.overlay = false
            if (!result.data.error) {
              this.dialog.show = false
              this.load()
            }
          })
          .catch(e => {
            this.overlay = false
            this.dialog.show = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load: function () {
        this.overlay = true
        this.axios.post('/api/accident/get', this.form)
          .then(result => {
            this.overlay = false
            if (!result.data.error) {
              this.items = result.data.data
              for (let x in this.items) {
                this.items[x].common.date_formatted = moment(this.items[x].common.date).format('DD.MM.YYYY')
                this.items[x].first.driver.birthday = moment(this.items[x].first.driver.birthday).format('DD.MM.YYYY')
                if (this.items[x].second) {
                  this.items[x].second.driver.birthday = moment(this.items[x].second.driver.birthday).format('DD.MM.YYYY')
                }
                this.items[x].state_text = this.dict.state[this.items[x].state]
                console.log(this.items[x].docs)
                for (let y in this.items[x].docs) {
                  if (this.items[x].docs[y].created) this.items[x].docs[y].created = moment(this.items[x].docs[y].created).format('DD.MM.YYYY HH:mm')
                }
              }
            }
          })
          .catch(e => {
            this.overlay = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
